import { EUROINCASSO_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa/index.js';
import { useFee } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React, { useState } from 'react';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import Button from '../../Button.js';
import { Plus } from '../../Icons/index.js';
import Modal from '../../Modal.js';
import ParkingLotRemarks, { AddParkingLotRemark, } from '../../Parking/ParkingLotRemarks.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
const ParkingLotRemarksCmp = (props) => {
    const { caseVoucher } = props;
    const [addRemarkModalOpen, setAddRemarkModalOpen] = useState(false);
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    // EuroIncasso can see remarks by Apcoa, but not add new ones
    const canAddRemark = !EUROINCASSO_TENANT_IDS.includes(caseVoucher.tenantId);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(feeLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            h.hasData(feeLoadable) && fee ? (React.createElement(React.Fragment, null,
                canAddRemark && (React.createElement(Button, { onClick: () => setAddRemarkModalOpen(!addRemarkModalOpen), style: { marginTop: '10px' }, size: "small" },
                    React.createElement(Plus, null),
                    " Tilf\u00F8j bem\u00E6rkning til pladsen")),
                fee.parkingLotCode && (React.createElement(ParkingLotRemarks, { parkingLotReferenceId: fee.parkingLotCode })),
                addRemarkModalOpen && (React.createElement(Modal, { header: 'Tilføj bemærkning til pladsen', maxWidth: "600px", onToggle: () => setAddRemarkModalOpen(!addRemarkModalOpen) },
                    React.createElement(AddParkingLotRemark, { parkingLotReferenceId: fee.parkingLotCode, onAdd: () => setAddRemarkModalOpen(false) }))))) : (!h.isError(feeLoadable) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" })))))));
};
export default ParkingLotRemarksCmp;
//# sourceMappingURL=ParkingLotRemarks.js.map